import * as msal from "@azure/msal-browser";

/** Configuração da instância MSAL: client ID, authority do tenant e cache em localStorage. */
export const msalConfig: msal.Configuration = {
  auth: {
    clientId: process.env.MSAL_CLIENT_ID || "",
    authority: "https://login.microsoftonline.com/fd6cba65-abab-4c6e-a219-ac8cea8a375b",
    redirectUri: window.location.origin + "/index.html",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

/** Escopos solicitados no login: leitura do perfil e dos e-mails, com refresh token. */
export const loginRequest: msal.PopupRequest = {
  scopes: ["User.Read", "Mail.Read", "offline_access"],
};
